module.exports = __webpack_public_path__ + "media/images/3_3-dbee9c61bed5ee206db9c5d82b3f4d0b.png";